import React from "react";
import TheatreAndScreensDetailsPanel from "../TargetGroupTable";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import { LogRenderContext } from "../LogRenderer";
import { applyScreenModifications } from "../utils";

const ScreenTab = () => {
  const { log } = React.useContext(LogRenderContext);
  const { targetGroups } = log.dataSnapshot;
  const { targetGroups: targetGroupsChanges } = log.changedFields || [];
  if (!targetGroups || targetGroups.length === 0) {
    return (
      <div className={styles.noDataContainer}>
        <div>No screens found</div>
      </div>
    );
  }
  const screens =
    targetGroups?.length > 0
      ? targetGroups
          .map((tg) => tg.screens)
          .flat()
          .filter((f) => f)
      : [];
  const screenChanges =
    targetGroupsChanges?.length > 0
      ? targetGroupsChanges
          .map((tg) => tg.screens)
          .filter((t) => t)
          .flat()
      : [];
  const { screensWithChanges } = applyScreenModifications(screens, screenChanges);
  return (
    <TheatreAndScreensDetailsPanel
      screens={screensWithChanges || []}
      targetGroupsName={targetGroups.map((tg) => tg.name)}
    />
  );
};

export default ScreenTab;
